import React, { useContext, useEffect } from "react";
import {
  Redirect,
  Switch,
  useHistory,
  useParams,
  withRouter,
} from "react-router-dom";
import PublicRouter from "./public";
import UserRouter from "./user";

import LandingPage from "../pages/landing/landing";
import ApplicationPage from "../pages/application/application";
import ApplicationConfirmationPage from "../pages/application/applicationConfirmation";
import ApplicationResultPage from "../pages/application/applicationResult";

import UserLoginPage from "../pages/user/login/login";
import ApplicationDetailPage from "../pages/user/applicationDetail/applicationDetail";
import PaymentStatusPage from "../pages/user/paymentStatus/paymentStatus";
import ActivityLogPage from "../pages/user/activityLog/activityLog";
import AlipayPage from "../pages/alipay/alipay";
import FPSPage from "../pages/fps/fps";
import { setting } from "../apis/setting";

import moment from "moment";

import { PAGE } from "../utils/constants";
import { AppContext } from "../App";
import CustomHTMLPage from "../pages/customHTML/customHtml";

function AppRouter() {
  let history = useHistory();
  const { pid } = useParams();
  const { appSetting, setAppSetting, setLoading } = useContext(AppContext);

  useEffect(() => {
    if (!pid) {
      history.replace("/error");
    } else {
      getSetting();
      moment.locale("en");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps,
  }, []);

  const getSetting = async () => {
    setLoading(true);
    try {
      const res = await setting(pid);
      if (res.error) {
        history.push({
          pathname: PAGE.ERROR,
          state: {
            status: "404",
            message: "課程不存在",
            path: "",
            button: "",
          },
        });
        throw new Error(`${res.error.msgCode} - ${res.error.message}`);
      } else {
        const { programId, configuration } = res;
        const { payment, checkResult, applicationSuccess, receipt } =
          configuration;
        setAppSetting({
          ...appSetting,

          programId: programId,
          title: configuration.title,
          logo: configuration.logo,
          image: configuration.image,
          description: configuration.description,
          maxApplicationCount: configuration.maxApplicationCount,
          applicationCount: configuration.applicationCount,
          language: configuration.language,
          enrolButton: configuration.enrolButton,
          paymentEnabled: payment.enabled,
          paymentMethod: payment.paymentMethod,
          checkResultButton: checkResult.name,
          checkResultForm: checkResult.fields,
          checkResultSubmit: checkResult.submitButton,
          activated: configuration.activated,
          deactivatedMsg: configuration.deactivatedMsg,
          enrolmentEnabled: configuration.enrolmentEnabled,
          enrolmentDisabledMsg: configuration.enrolmentDisabledMsg,
          applicationSuccessTitle: applicationSuccess.title,
          applicationSuccessDescription: applicationSuccess.description,
          receiptRemarks: receipt.remarks,
          receiptFooter: receipt.footer,
          receiptFooterLogo: receipt.footerLogo,
        });
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Switch>
      <PublicRouter path={PAGE.LANDING} component={LandingPage} />
      <PublicRouter path={PAGE.APPLICATION} component={ApplicationPage} />
      <PublicRouter
        exact
        path={PAGE.APPLICATION_CONFIRM}
        component={ApplicationConfirmationPage}
      />
      <PublicRouter
        exact
        path={PAGE.APPLICATION_RESULT}
        component={ApplicationResultPage}
      />
      <PublicRouter exact path={PAGE.USER_LOGIN} component={UserLoginPage} />
      <PublicRouter exact path={PAGE.ALIPAY} component={AlipayPage} />
      <PublicRouter exact path={PAGE.FPS} component={FPSPage} />
      <PublicRouter exact path={PAGE.CUSTOM_HTML} component={CustomHTMLPage} />

      <UserRouter
        path={PAGE.USER_APPLICATION_DETAIL}
        component={ApplicationDetailPage}
      />
      <UserRouter path={PAGE.USER_PAYMENT} component={PaymentStatusPage} />
      <UserRouter path={PAGE.USER_ACTIVITY_LOG} component={ActivityLogPage} />

      <Redirect to={PAGE.LANDING} />
    </Switch>
  );
}

export default withRouter(AppRouter);
